import { db } from '@/firebase';
import systemDeviceTypesJSON from '@resources/system_device_types.json';

export default () => db.ref('/system_device_types').set(systemDeviceTypesJSON);
